import {
	BaseDataItem,
	Data,
	PresetData,
	PresetsDataMap,
	ResolvedVariantRelation,
	ResolvedVariantsRefArray,
	Style,
	UnresolvedRefArray,
	UnresolvedVariantRelation,
} from '@wix/thunderbolt-becky-types'
import { RefData } from '../types/byRef'
import { removeHash } from './utils'

const resolvePresetsRefArray = (
	presetsRefArray: UnresolvedRefArray,
	presetsDataMap: PresetsDataMap
): Array<PresetData | ResolvedVariantRelation<PresetData>> =>
	presetsRefArray.values.map((itemId) => {
		const resolvedItem = presetsDataMap[removeHash(itemId)]
		return resolvedItem.type === 'VariantRelation'
			? ({
					...resolvedItem,
					to: presetsDataMap[removeHash((resolvedItem as UnresolvedVariantRelation).to)],
			  } as ResolvedVariantRelation<PresetData>)
			: (resolvedItem as PresetData)
	})

export const getPresetsArray = (
	presetQuery: string,
	presetsDataMap: PresetsDataMap
): ResolvedVariantsRefArray<PresetData>['values'] => {
	const presetsItem = presetsDataMap[presetQuery]
	if (!presetsItem) {
		return []
	}
	if (presetsItem.type === 'RefArray') {
		return resolvePresetsRefArray(presetsItem, presetsDataMap)
	}
	return [presetsItem as PresetData]
}

const isPresetRefArray = (
	refArray: UnresolvedRefArray,
	data: Data | RefData,
	dataMapName: 'layout_data' | 'theme_data'
): boolean => {
	const variantsData = data.variants_data

	return refArray.values.some((value) => {
		const resolvedValue = data[dataMapName][removeHash(value)]
		const isVariantRelation = resolvedValue.type === 'VariantRelation'
		if (!isVariantRelation || !(resolvedValue as ResolvedVariantRelation<Style>).variants.length) {
			return false
		}
		const presetCondition = variantsData[removeHash((resolvedValue as ResolvedVariantRelation<Style>).variants[0])]
		return presetCondition && presetCondition.type === 'Preset'
	})
}

export const shouldResolveRefArray = (
	dataItem: BaseDataItem<string>,
	data: Data | RefData,
	mapName: keyof Data,
	presets: ResolvedVariantsRefArray<PresetData>['values']
) => {
	const isLayoutOrStyle = mapName === 'layout_data' || mapName === 'theme_data'
	const isRefArray = dataItem.type === 'RefArray'

	return (
		isLayoutOrStyle &&
		isRefArray &&
		presets.length &&
		isPresetRefArray(dataItem as UnresolvedRefArray, data, mapName as 'layout_data' | 'theme_data')
	)
}
